import React from 'react';
import {Container, Form, Button, Card, Row, Col, ButtonGroup} from 'react-bootstrap';
import {router, useForm, usePage} from '@inertiajs/react';
import { useLaravelReactI18n } from 'laravel-react-i18n';
import Icon from "@mdi/react";
import {mdiTrashCan} from "@mdi/js";

function Edit() {
    const { t } = useLaravelReactI18n();
    const { recurringtransaction,userNames } = usePage().props;

    let Carbon;
    const { data, setData, post, processing, progress, transform, errors } = useForm(recurringtransaction ? {
        type: recurringtransaction.type,
        amount: recurringtransaction.amount,
        description: recurringtransaction.description,
        user_id: recurringtransaction.user_id,
        date: recurringtransaction.date,
        interval:recurringtransaction.interval,
        day: recurringtransaction.day
    } : {
        type: 'expense',
        amount: '',
        description: '',
        user_id: 1,
        day: 1,
        interval:1
    });

    transform((data) => {
        console.log("adding _method if needed");
        if (recurringtransaction) {
            return {
                ...data,
                _method: 'PUT',
            };
        }
        return data;
    });

    function handleChange(e) {
        const key = e.target.id;
        const value = e.target.value;
        setData({
            ...data,
            [key]: value,
        })
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (recurringtransaction) {
            post(`/recurring-transactions/${recurringtransaction.id}`, {forceFormData: true});
        }
        else {
            post(`/recurring-transactions`, { forceFormData: true });
        }
    }

    function handleDeleteButtonClick() {
        router.post(`/recurring-transactions/${recurringtransaction.id}`,{_method:'delete'});
    }

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Card>
                    <Card.Header className={"d-flex justify-content-between"}>
                        <h5>{t(recurringtransaction ? 'Edit recurring transaction' : 'Create recurring transaction')}</h5>
                        <ButtonGroup>
                            <Button className={'ms-2'} variant="secondary"  title={t('delete')} onClick={handleDeleteButtonClick}>
                                <Icon path={mdiTrashCan} size={1}/>
                            </Button>
                            <Button variant="primary" type="submit" disabled={processing}>
                                {t('save')}
                            </Button>
                        </ButtonGroup>
                    </Card.Header>
                    <Card.Body>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('Type')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    as="select"
                                    className={errors.type ? 'is-invalid' : ''}
                                    id="type"
                                    value={data.type}
                                    onChange={handleChange}
                                >
                                    <option value="">{t('Select type')}</option>
                                    <option value="income">{t('income')}</option>
                                    <option value="expense">{t('expense')}</option>
                                    <option value="balancing">{t('balancing')}</option>
                                </Form.Control>
                                {errors.type && <div className="invalid-feedback">{errors.type}</div>}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('Amount')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    className={errors.amount ? 'is-invalid' : ''}
                                    placeholder={t('Enter amount')}
                                    id="amount"
                                    type="number"
                                    value={data.amount}
                                    onChange={handleChange}
                                />
                                {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('Interval')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    as="select"
                                    className={errors.interval ? 'is-invalid' : ''}
                                    id="interval"
                                    value={data.interval}
                                    onChange={handleChange}
                                >
                                    <option value="1">{t('monthly')}</option>
                                    <option value="6">{t('half-year')}</option>
                                    <option value="12">{t('year')}</option>
                                </Form.Control>
                                {errors.interval && <div className="invalid-feedback">{errors.interval}</div>}
                            </Col>
                        </Form.Group>


                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('Day')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    className={errors.day ? 'is-invalid' : ''}
                                    placeholder={t('Enter Day')}
                                    id="day"
                                    type="number"
                                    min={1}
                                    max={31}
                                    value={data.day}
                                    onChange={handleChange}
                                />
                                {errors.day && <div className="invalid-feedback">{errors.day}</div>}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('Description')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    className={errors.description ? 'is-invalid' : ''}
                                    placeholder={t('Enter description')}
                                    id="description"
                                    type="text"
                                    value={data.description}
                                    onChange={handleChange}
                                />
                                {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={2}>
                                {t('User')}
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control
                                    as="select"
                                    className={errors.user_id ? 'is-invalid' : ''}
                                    id="user_id"
                                    value={data.user_id}
                                    onChange={handleChange}
                                >
                                    <option value="">{t('Select user')}</option>

                                    {Object.entries(userNames).map((user, index) => (
                                        <option key={index} value={user[0]}>{user[1]}</option>
                                    ))}
                                </Form.Control>
                                {errors.user_id && <div className="invalid-feedback">{errors.user_id}</div>}
                            </Col>
                        </Form.Group>


                    </Card.Body>
                </Card>
            </Form>
        </Container>
    );
}
export default Edit;
